import styled from 'styled-components';

export const StyledDiscountCode = styled.div`
  .discount-code-btn {
    display: flex;
    align-items: center;
    justify-content: center;

    &-skeleton {
      width: 13.375rem;
    }
  }

  .discount-code {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;
    margin-top: 0.5rem;
    margin-bottom: 1rem;

    .discount-badge {
      cursor: pointer;
      padding: 0.125rem 0.5rem;
      border-radius: 1rem;
      width: fit-content;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0.25rem;
      background: rgba(0, 0, 0, 0.1);

      .discount-text {
        font-weight: 700;
      }
    }
  }
`;
